import {MbDatatablesTemplate} from "../mb-datatables-template";

export class MbActionModel {
    public iconName;
    public title: string;
    public click;
    public references;
    public service;
    public expression: any;


    constructor(iconName, click, title, expression?) {
        this.iconName = iconName;
        this.click = click;
        this.title = title;
        this.expression = expression;
    }

    getIconName(row) {
        if (typeof this.iconName == 'string') {
            return this.iconName;
        }
        return this.iconName(row);
    }

}

export class MbColInput {
    public static SELECT='select';
    public static TEXT='text';
    type: string;
    options: any[];
    defaultValue: any;

    constructor(type: string, options?: any[], defaultValue?: any) {
        this.type = type;
        this.options = options;
        this.defaultValue = defaultValue;
    }

    public static new(type: string, options?: any[], defaultValue?: any):MbColInput{
        return new MbColInput(type, options, defaultValue);
    }
    public static newDefaultText():MbColInput{
        return new MbColInput(MbColInput.TEXT);
    }
}

export class MbColDefinition {
    resizeable: boolean = false;
    prop: string;
    name: string;
    headerTemplate: string = MbDatatablesTemplate.HEADER_TEMPLATE;
    cellTemplate: string;
    input: MbColInput;
    sortable: boolean = true;

    constructor(prop: string, name: string, input?: MbColInput, cellTemplate?: string, sortable?: boolean, resizeable?: boolean) {
        this.resizeable = resizeable ? resizeable : false;
        this.prop = prop;
        this.name = name;
        this.cellTemplate = cellTemplate;
        this.input = input ? input : new MbColInput('text');
        this.sortable = sortable ? sortable : true;
    }

    public static new(prop: string, name: string, input?: MbColInput, cellTemplate?: string, sortable?: boolean, resizeable?: boolean): MbColDefinition {
        return new MbColDefinition(prop, name, input, cellTemplate, sortable, resizeable);
    }
}
export class MbSort{
    public static DESC = 'desc';
    public static ASC = 'asc';
    prop:string;
    dir:string;

    constructor(prop: string, dir: string) {
        this.prop = prop;
        this.dir = dir;
    }
}
